export default "__VITE_ASSET__sI4d8hM9__"